import {CLStore} from 'common/src/redux/store';
import initializeAnalyticsAgents from './initializeAnalyticsAgents';
import initializeAnalyticsUiContexts from './initializeAnalyticsUiContexts';

function initializeAnalytics(store: CLStore) {
  initializeAnalyticsUiContexts(store);
  initializeAnalyticsAgents(store);
}

export default initializeAnalytics;
